var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-user--trash"},[_c('sortable-list',{staticClass:"page-list",attrs:{"title":_vm.$t('list-user.list-title'),"default-sort":"firstname","selectable":"multiple","items":_vm.filter,"parameters":_vm.trashListParameters,"has-pagination":_vm.pagination},on:{"selected":_vm.onSelect,"item-click":_vm.itemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }